<template>
    <div style="margin-top: 20px;">
        <div v-if="!componentIsLoading">
            <table class="table" v-if="internalDocuments.length > 0">
                <thead>
                    <tr>
                        <th>Document</th>
                        <th></th>
                    </tr>
                </thead>
    
                <item v-for="(internalDocument, idx) in internalDocuments"
                    :key="'internal-document-' + idx"
                    :ref="'internalDocument' + idx"
                    :index="idx"
                    :customer-id="customerId"
                    :internal-document="internalDocument"
                    @file-uploaded="onFileUploaded($event)"
                    @file-deleted="onFileDeleted($event)"
                    @last-file-deleted="onLastFileDeleted($event)"
                ></item>
            </table>
    
            <p v-else>Aucun document n'a été ajouté pour le moment.</p>
        </div>

        <component-loader v-else></component-loader>
    </div>
</template>

<script type="text/babel">
import {mapState, mapActions} from "vuex"
import Item from './Item'
import ComponentLoader from 'components/ComponentLoader'

export default {
    name: "DocumentsList",
    
    components: {
        Item,
        ComponentLoader
    },

    data() {
        return {
            componentIsLoading: false
        }
    },

    mounted() {
        this.fetchDocuments()
    },

    computed: {
        ...mapState('customer', {
            customerId: 'id',
            internalDocuments: 'internal_documents'
        })
    }, 

    methods: {
        ...mapActions('customer', ['fetchInternalDocuments']),

        getItemComponent(index) {
            return this.$refs['internalDocument' + index][0]
        },
        getItemDetailComponent(index) {
            return this.getItemComponent(index).$refs['itemDetail']
        },

        fetchDocuments() {
            this.componentIsLoading = true

            this.fetchInternalDocuments()
                .then(() => this.componentIsLoading = false)
        },
        onFileUploaded(index) {
            this.getItemDetailComponent(index).fetchInternalDocument()
        },
        onFileDeleted(index) {
            this.getItemDetailComponent(index).fetchInternalDocument()
        },
        onLastFileDeleted(index) {
            this.fetchInternalDocuments()
        }
    }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// client/components/Customer/InternalDocuments/List.vue